export const adminAccounts = {
  "admin.accounts.pageTitle": "Gestión de Cuentas",
  "admin.accounts.pageDescription": "Gestionar y ver todas las cuentas de usuario en el sistema",
  "admin.accounts.title": "Gestión de Cuentas", 
  "admin.accounts.subtitle": "Ver y gestionar todas las cuentas de usuario con opciones completas de filtrado y ordenación",
  "admin.accounts.errorTitle": "Error al Cargar Cuentas",
  "admin.accounts.errorMessage": "Error al cargar los datos de cuentas. Por favor, inténtelo de nuevo.",
  "admin.accounts.retryButton": "Reintentar",

  // Filters section
  "admin.accounts.filters.title": "Filtros de Cuentas",
  "admin.accounts.filters.accountInformationTitle": "Información de Cuenta",
  "admin.accounts.filters.dateRangeTitle": "Rango de Fechas",
  "admin.accounts.filters.balanceRangeTitle": "Rango de Saldos",
  "admin.accounts.filters.accountNumber": "Número de Cuenta",
  "admin.accounts.filters.accountNumberPlaceholder": "Ingrese el número exacto de cuenta",
  "admin.accounts.filters.username": "Nombre de Usuario", 
  "admin.accounts.filters.usernamePlaceholder": "Ingrese el nombre exacto de usuario",
  "admin.accounts.filters.accountStatus": "Estado de Cuenta",
  "admin.accounts.filters.accountStatusPlaceholder": "Seleccione el estado de cuenta",
  "admin.accounts.filters.allStatuses": "Todos los Estados",
  "admin.accounts.filters.dateFrom": "Cuenta Abierta Desde (yyyy-mm-dd)",
  "admin.accounts.filters.dateTo": "Cuenta Abierta Hasta (yyyy-mm-dd)",
  "admin.accounts.filters.accountShareType": "Tipo de Participación de Cuenta",
  "admin.accounts.filters.accountShareTypePlaceholder": "Seleccione tipo de participación",
  "admin.accounts.filters.allShareTypes": "Todos los Tipos de Participación",
  "admin.accounts.filters.programPercent": "Porcentaje de Programa",
  "admin.accounts.filters.programPercentPlaceholder": "Seleccione porcentaje de programa",
  "admin.accounts.filters.allProgramPercents": "Todos los Porcentajes de Programa",
  "admin.accounts.filters.balanceMin": "Saldo Mínimo",
  "admin.accounts.filters.balanceMinPlaceholder": "Ingrese saldo mínimo",
  "admin.accounts.filters.balanceMax": "Saldo Máximo", 
  "admin.accounts.filters.balanceMaxPlaceholder": "Ingrese saldo máximo",
  "admin.accounts.filters.applyFilters": "Aplicar Filtros",
  "admin.accounts.filters.clearFilters": "Limpiar Filtros",

  // Table section
  "admin.accounts.table.title": "Cuentas de Usuario",
  "admin.accounts.table.showing": "Mostrando",
  "admin.accounts.table.of": "de",
  "admin.accounts.table.accounts": "cuentas",
  "admin.accounts.table.accountNumber": "Número de Cuenta",
  "admin.accounts.table.username": "Nombre de Usuario",
  "admin.accounts.table.name": "Nombre",
  "admin.accounts.table.status": "Estado",
  "admin.accounts.table.shareType": "Tipo de Participación",
  "admin.accounts.table.programPercent": "Programa %",
  "admin.accounts.table.balance": "Saldo", 
  "admin.accounts.table.creationDate": "Fecha de Creación",
  "admin.accounts.table.lastUpdate": "Última Actualización",
  "admin.accounts.table.errorMessage": "Error al cargar datos de cuentas",
  "admin.accounts.table.noDataMessage": "No se encontraron cuentas que coincidan con los filtros actuales",

  // Status translations
  "admin.accounts.table.status.active": "Activo",
  "admin.accounts.table.status.inactive": "Inactivo",

  // Profits page translations
  "admin.accounts.profits.pageTitle": "Gestión de Beneficios de Cuentas",
  "admin.accounts.profits.pageDescription": "Ver y analizar el historial de beneficios de cuentas con opciones de filtrado completas",
  "admin.accounts.profits.title": "Gestión de Beneficios de Cuentas",
  "admin.accounts.profits.subtitle": "Vista completa del historial de beneficios de cuentas con filtros y análisis avanzados",
  "admin.accounts.profits.errorTitle": "Error al Cargar Datos de Beneficios",
  "admin.accounts.profits.errorMessage": "Error al cargar los datos de beneficios de cuentas. Por favor, inténtelo de nuevo.",
  "admin.accounts.profits.retryButton": "Reintentar",

  // Profits filters section
  "admin.accounts.profits.filters.title": "Filtros de Beneficios",
  "admin.accounts.profits.filters.accountInformationTitle": "Información de Cuenta",
  "admin.accounts.profits.filters.periodTitle": "Período",
  "admin.accounts.profits.filters.profitsTitle": "Beneficios",
  "admin.accounts.profits.filters.accountNumber": "Número de Cuenta",
  "admin.accounts.profits.filters.accountNumberPlaceholder": "Ingrese el número exacto de cuenta",
  "admin.accounts.profits.filters.username": "Nombre de Usuario",
  "admin.accounts.profits.filters.usernamePlaceholder": "Ingrese el nombre exacto de usuario",
  "admin.accounts.profits.filters.accountShare": "Participación de Cuenta",
  "admin.accounts.profits.filters.accountSharePlaceholder": "Seleccione tipo de participación de cuenta",
  "admin.accounts.profits.filters.allAccountShares": "Todos los Tipos de Participación",
  "admin.accounts.profits.filters.dateFrom": "Período Desde (yyyy-mm-dd)",
  "admin.accounts.profits.filters.dateTo": "Período Hasta (yyyy-mm-dd)",
  "admin.accounts.profits.filters.userProfitRange": "Rango de Beneficio de Usuario",
  "admin.accounts.profits.filters.userProfitMin": "Beneficio Mínimo de Usuario",
  "admin.accounts.profits.filters.userProfitMinPlaceholder": "Ingrese beneficio mínimo de usuario",
  "admin.accounts.profits.filters.userProfitMax": "Beneficio Máximo de Usuario",
  "admin.accounts.profits.filters.userProfitMaxPlaceholder": "Ingrese beneficio máximo de usuario",
  "admin.accounts.profits.filters.tradingProfitRange": "Rango de Beneficio de Trading",
  "admin.accounts.profits.filters.tradingProfitMin": "Beneficio Mínimo de Trading",
  "admin.accounts.profits.filters.tradingProfitMinPlaceholder": "Ingrese beneficio mínimo de trading",
  "admin.accounts.profits.filters.tradingProfitMax": "Beneficio Máximo de Trading",
  "admin.accounts.profits.filters.tradingProfitMaxPlaceholder": "Ingrese beneficio máximo de trading",
  "admin.accounts.profits.filters.programProfitRange": "Rango de Beneficio de Programa",
  "admin.accounts.profits.filters.programProfitMin": "Beneficio Mínimo de Programa",
  "admin.accounts.profits.filters.programProfitMinPlaceholder": "Ingrese beneficio mínimo de programa",
  "admin.accounts.profits.filters.programProfitMax": "Beneficio Máximo de Programa",
  "admin.accounts.profits.filters.programProfitMaxPlaceholder": "Ingrese beneficio máximo de programa",
  "admin.accounts.profits.filters.applyFilters": "Aplicar Filtros",
  "admin.accounts.profits.filters.clearFilters": "Limpiar Filtros",

  // Profits table section
  "admin.accounts.profits.table.title": "Datos de Beneficios de Cuenta",
  "admin.accounts.profits.table.showing": "Mostrando",
  "admin.accounts.profits.table.of": "de",
  "admin.accounts.profits.table.records": "registros",
  "admin.accounts.profits.table.accountNumber": "Número de Cuenta",
  "admin.accounts.profits.table.username": "Nombre de Usuario",
  "admin.accounts.profits.table.name": "Nombre",
  "admin.accounts.profits.table.shareType": "Tipo de Participación",
  "admin.accounts.profits.table.period": "Período",
  "admin.accounts.profits.table.userProfit": "Beneficio de Usuario",
  "admin.accounts.profits.table.tradingProfit": "Beneficio de Trading",
  "admin.accounts.profits.table.programProfit": "Beneficio de Programa",
  "admin.accounts.profits.table.errorMessage": "Error al cargar datos de beneficios",
  "admin.accounts.profits.table.noDataMessage": "No se encontraron registros de beneficios que coincidan con los filtros actuales",

  // Profits Totals page translations
  "admin.accounts.profitsTotals.title": "Gestión de Totales de Beneficios de Cuentas",
  "admin.accounts.profitsTotals.subtitle": "Ver y analizar los beneficios totales de las cuentas con opciones de filtrado completas",
  "admin.accounts.profitsTotals.errorTitle": "Error al Cargar los Totales de Beneficios",
  "admin.accounts.profitsTotals.errorMessage": "Error al cargar los datos de totales de beneficios de cuentas. Por favor, inténtelo de nuevo.",
  "admin.accounts.profitsTotals.retryButton": "Reintentar",

  // Profits Totals filters section
  "admin.accounts.profitsTotals.filters.title": "Filtros de Totales de Beneficios",
  "admin.accounts.profitsTotals.filters.accountInformationTitle": "Información de la Cuenta",
  "admin.accounts.profitsTotals.filters.profitsTitle": "Beneficios",
  "admin.accounts.profitsTotals.filters.accountNumber": "Número de Cuenta",
  "admin.accounts.profitsTotals.filters.accountNumberPlaceholder": "Ingrese el número de cuenta exacto",
  "admin.accounts.profitsTotals.filters.username": "Nombre de Usuario",
  "admin.accounts.profitsTotals.filters.usernamePlaceholder": "Ingrese el nombre de usuario exacto",
  "admin.accounts.profitsTotals.filters.accountShare": "Participación de Cuenta",
  "admin.accounts.profitsTotals.filters.accountSharePlaceholder": "Seleccione el tipo de participación de cuenta",
  "admin.accounts.profitsTotals.filters.allAccountShares": "Todos los Tipos de Participación",
  "admin.accounts.profitsTotals.filters.userProfitRange": "Rango de Beneficio del Usuario",
  "admin.accounts.profitsTotals.filters.userProfitMin": "Beneficio Mínimo del Usuario",
  "admin.accounts.profitsTotals.filters.userProfitMinPlaceholder": "Ingrese el beneficio mínimo del usuario",
  "admin.accounts.profitsTotals.filters.userProfitMax": "Beneficio Máximo del Usuario",
  "admin.accounts.profitsTotals.filters.userProfitMaxPlaceholder": "Ingrese el beneficio máximo del usuario",
  "admin.accounts.profitsTotals.filters.tradingProfitRange": "Rango de Beneficio de Trading",
  "admin.accounts.profitsTotals.filters.tradingProfitMin": "Beneficio Mínimo de Trading",
  "admin.accounts.profitsTotals.filters.tradingProfitMinPlaceholder": "Ingrese el beneficio mínimo de trading",
  "admin.accounts.profitsTotals.filters.tradingProfitMax": "Beneficio Máximo de Trading",
  "admin.accounts.profitsTotals.filters.tradingProfitMaxPlaceholder": "Ingrese el beneficio máximo de trading",
  "admin.accounts.profitsTotals.filters.programProfitRange": "Rango de Beneficio del Programa",
  "admin.accounts.profitsTotals.filters.programProfitMin": "Beneficio Mínimo del Programa",
  "admin.accounts.profitsTotals.filters.programProfitMinPlaceholder": "Ingrese el beneficio mínimo del programa",
  "admin.accounts.profitsTotals.filters.programProfitMax": "Beneficio Máximo del Programa",
  "admin.accounts.profitsTotals.filters.programProfitMaxPlaceholder": "Ingrese el beneficio máximo del programa",
  "admin.accounts.profitsTotals.filters.applyFilters": "Aplicar Filtros",
  "admin.accounts.profitsTotals.filters.clearFilters": "Limpiar Filtros",

  // Profits Totals table section
  "admin.accounts.profitsTotals.table.title": "Datos de Totales de Beneficios de Cuentas",
  "admin.accounts.profitsTotals.table.showing": "Mostrando",
  "admin.accounts.profitsTotals.table.of": "de",
  "admin.accounts.profitsTotals.table.records": "registros",
  "admin.accounts.profitsTotals.table.accountNumber": "Número de Cuenta",
  "admin.accounts.profitsTotals.table.username": "Nombre de Usuario",
  "admin.accounts.profitsTotals.table.name": "Nombre",
  "admin.accounts.profitsTotals.table.shareType": "Tipo de Participación",
  "admin.accounts.profitsTotals.table.userProfit": "Beneficio del Usuario",
  "admin.accounts.profitsTotals.table.tradingProfit": "Beneficio de Trading",
  "admin.accounts.profitsTotals.table.programProfit": "Beneficio del Programa",
  "admin.accounts.profitsTotals.table.errorMessage": "Error al cargar los datos de totales de beneficios",
  "admin.accounts.profitsTotals.table.noDataMessage": "No se encontraron totales de beneficios que coincidan con los filtros actuales",

  // Profits Registration page translations
  "admin.accounts.profitsRegistration.title": "Registrar Beneficios de Trading",
  "admin.accounts.profitsRegistration.subtitle": "Registrar beneficios mensuales de trading para todas las cuentas de broker en el sistema",
  "admin.accounts.profitsRegistration.registerSection.title": "Registrar Beneficios de Trading",
  "admin.accounts.profitsRegistration.registerSection.monthLabel": "Mes",
  "admin.accounts.profitsRegistration.registerSection.monthDescription": "El formato del mes es \"yyyy-mm-01\", los beneficios del mes anterior se registran el primer día del mes actual.",
  "admin.accounts.profitsRegistration.registerSection.monthPlaceholder": "yyyy-mm-01",
  "admin.accounts.profitsRegistration.registerSection.registerButton": "Registrar Beneficios de Trading",
  "admin.accounts.profitsRegistration.resultSection.title": "Resultado",
  "admin.accounts.profitsRegistration.resultSection.operationResult": "Resultado de Operación",
  "admin.accounts.profitsRegistration.resultSection.success": "Éxito",
  "admin.accounts.profitsRegistration.resultSection.fail": "Fallo",
  "admin.accounts.profitsRegistration.resultSection.numBrokerAccounts": "Núm cuentas broker",
  "admin.accounts.profitsRegistration.resultSection.numRegisteredAccounts": "Núm cuentas registradas",
  "admin.accounts.profitsRegistration.resultSection.accountsNotRegistered": "Cuentas no registradas",
  "admin.accounts.profitsRegistration.resultSection.accountsAlreadyRegistered": "Beneficios de cuentas ya registrados",
  "admin.accounts.profitsRegistration.resultSection.totalProfit": "Beneficio Total",
  
  // Validation messages
  "admin.accounts.profitsRegistration.validation.invalidFormat": "El mes debe estar en formato yyyy-mm-01",
  "admin.accounts.profitsRegistration.validation.invalidDate": "Fecha no válida",
  "admin.accounts.profitsRegistration.validation.invalidMonth": "El mes debe estar entre 01 y 12",
  "admin.accounts.profitsRegistration.validation.futureMonth": "No se pueden registrar beneficios para meses futuros",

  // Toast messages
  "admin.accounts.profitsRegistration.messages.success": "Beneficios Registrados Exitosamente",
  "admin.accounts.profitsRegistration.messages.successDescription": "Beneficios de cuenta registrados exitosamente",
  "admin.accounts.profitsRegistration.messages.error": "Error de Registro",
  "admin.accounts.profitsRegistration.messages.csrfError": "No se pudo generar el token de seguridad",
  "admin.accounts.profitsRegistration.messages.authError": "Se requiere autenticación",
  "admin.accounts.profitsRegistration.messages.serverError": "Ocurrió un error del servidor",
  "admin.accounts.profitsRegistration.messages.operationFailed": "Falló el registro de beneficios",
  "admin.accounts.profitsRegistration.messages.unexpectedError": "Ocurrió un error inesperado",

  // Balance Update page translations
  "admin.accounts.balanceUpdate.title": "Actualizar Saldos de Cuentas",
  "admin.accounts.balanceUpdate.subtitle": "Actualizar el saldo actual de todas las cuentas de trading desde el sistema del broker",
  "admin.accounts.balanceUpdate.updateSection.title": "Actualizar Saldos de Cuentas",
  "admin.accounts.balanceUpdate.updateSection.updateButton": "Actualizar Saldos de Cuentas",
  "admin.accounts.balanceUpdate.resultSection.title": "Resultado",
  "admin.accounts.balanceUpdate.resultSection.operationResult": "Resultado de Operación",
  "admin.accounts.balanceUpdate.resultSection.success": "Éxito",
  "admin.accounts.balanceUpdate.resultSection.fail": "Fallo",
  "admin.accounts.balanceUpdate.resultSection.numBrokerAccounts": "Núm cuentas broker",
  "admin.accounts.balanceUpdate.resultSection.numUpdatedAccounts": "Núm cuentas actualizadas",
  "admin.accounts.balanceUpdate.resultSection.accountsNotRegistered": "Cuentas no registradas",
  "admin.accounts.balanceUpdate.resultSection.totalFunds": "Fondos Totales",

  // Balance Update toast messages
  "admin.accounts.balanceUpdate.messages.success": "Saldos Actualizados Exitosamente",
  "admin.accounts.balanceUpdate.messages.successDescription": "Saldos de cuenta actualizados exitosamente",
  "admin.accounts.balanceUpdate.messages.error": "Error de Actualización",
  "admin.accounts.balanceUpdate.messages.csrfError": "No se pudo generar el token de seguridad",
  "admin.accounts.balanceUpdate.messages.authError": "Se requiere autenticación",
  "admin.accounts.balanceUpdate.messages.serverError": "Ocurrió un error del servidor",
  "admin.accounts.balanceUpdate.messages.operationFailed": "Falló la actualización de saldos",
  "admin.accounts.balanceUpdate.messages.unexpectedError": "Ocurrió un error inesperado",

  // Auto Account Registration page translations
  "admin.accounts.autoRegister.title": "Registro Automático de Cuentas",
  "admin.accounts.autoRegister.subtitle": "Registrar automáticamente cuentas de trading de usuarios desde el sistema de broker",
  "admin.accounts.autoRegister.registerSection.title": "Registrar Cuentas Automáticamente",
  "admin.accounts.autoRegister.registerSection.registerButton": "Registrar Cuentas Automáticamente",
  "admin.accounts.autoRegister.resultSection.title": "Resultado",
  "admin.accounts.autoRegister.resultSection.operationResult": "Resultado de Operación",
  "admin.accounts.autoRegister.resultSection.success": "Éxito",
  "admin.accounts.autoRegister.resultSection.fail": "Fallo",
  "admin.accounts.autoRegister.resultSection.matchedUsers": "Cuentas Coincidentes",
  "admin.accounts.autoRegister.resultSection.unmatchedUsers": "Cuentas No Coincidentes",
  "admin.accounts.autoRegister.resultSection.usersWithoutAccounts": "Usuarios Sin Cuentas",
  "admin.accounts.autoRegister.resultSection.ignoredOfferName": "Nombre de Oferta Ignorado",
  "admin.accounts.autoRegister.resultSection.ignoredIds": "IDs Ignorados",
  "admin.accounts.autoRegister.messages.success": "Registro Automático Completado Exitosamente",
  "admin.accounts.autoRegister.messages.successDescription": "Cuentas registradas exitosamente",
  "admin.accounts.autoRegister.messages.error": "Error de Registro Automático",
  "admin.accounts.autoRegister.messages.csrfError": "No se pudo generar el token de seguridad",
  "admin.accounts.autoRegister.messages.authError": "Se requiere autenticación",
  "admin.accounts.autoRegister.messages.serverError": "Ocurrió un error del servidor",
  "admin.accounts.autoRegister.messages.operationFailed": "Falló el registro automático",
  "admin.accounts.autoRegister.messages.unexpectedError": "Ocurrió un error inesperado",
};